<div class="login-form">
    <img class="img-logo" src="assets/images/logo-white.png" alt="MEGA AUTOS" />
    <form [formGroup]="formData" (ngSubmit)="onClickSubmit(formData.value)">
        <div class="form">
            <div class="m-b-15">
                <label class="label">E-mail</label>
                <input required type="text" id="username" formControlName="userName" placeholder="Username" autofocus />
            </div>
            <br />
            <div>
                <label class="label">Senha</label>
                <input required type="password" id="inputPassword" formControlName="password" placeholder="Password" />
            </div>
            <br />
            <br />
            <button class="btn btn-primary" type="submit">
                Entrar
                <div class="icon">
                    <i class="fal fa-chevron-right"></i>
                </div>
            </button>
        </div>
    </form>
    <a class="lnk-public-site" routerLink="">Voltar para o site</a>
</div>
<img class="img-bg" src="assets/images/login-bg.jpg" alt="MEGA AUTOS" />